module.exports = __webpack_public_path__ + "src/assets/img/cmd-close-trunk.3d456a5e.svg";